<template>
  <div>
    <template v-if="initialized">
      <the-header></the-header>

      <v-main>
        <router-view></router-view>
      </v-main>

      <the-footer v-if="showFooter"></the-footer>
    </template>

    <template v-else-if="loading">
      <loading-layout></loading-layout>
    </template>

    <template v-else>
      <error-layout
        :error="$t('error.serviceUnavailable')"
        :message="$t('error.tryAgain')"
      ></error-layout>
    </template>
  </div>
</template>

<script>
import { AuthMixin } from '@lib/vue-playrix-auth/mixins';

import LoadingLayout from '@/views/layouts/LoadingLayout.vue';
import ErrorLayout from '@/views/layouts/ErrorLayout.vue';
import TheHeader from '@/components/common/TheHeader.vue';
import TheFooter from '@/components/common/TheFooter.vue';

import HealthCheck from '@/api/http/health-check';

import { NOT_AUTHORIZED } from '@/config/events';
import { HIDE_AFFILIATION } from '@/config/features';

export default {
  data() {
    return {
      initialized: false,
      loading: false,
    };
  },
  computed: {
    showFooter() {
      return !HIDE_AFFILIATION;
    },
  },
  created() {
    this.setupDOMEvents();
    this.setupHubEvents();
  },
  beforeMount() {
    this.loading = true;

    this.initialize()
      .then(() => {
        this.initialized = true;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
  destroyed() {
    this.removeDOMEvents();
    this.removeHubEvents();
  },
  methods: {
    setupDOMEvents() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    removeDOMEvents() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    setupHubEvents() {
      this.$eventHub.$once(NOT_AUTHORIZED, this.handleNotAuthorized);
    },
    removeHubEvents() {
      this.$eventHub.$off(NOT_AUTHORIZED, this.handleNotAuthorized);
    },
    async initialize() {
      await this.serverHealthCheck();
      await this.refreshAuthToken();
    },
    async serverHealthCheck() {
      return HealthCheck.get().catch(error => {
        this.$toast.error(this.$t('error.serverUnavailable'));

        return Promise.reject(error);
      });
    },
    async refreshAuthToken() {
      return this.refreshToken().catch(error => {
        this.handleNotAuthorized();

        throw error;
      });
    },
    handleNotAuthorized() {
      this.deauthorize().then(() => this.$router.push({ name: 'auth' }));
    },
    handleVisibilityChange() {
      if (document.hidden || !this.initialized) {
        return;
      }

      this.refreshAuthToken().catch(error => {
        this.$toast.error(error.message);
      });
    },
  },
  components: {
    LoadingLayout,
    ErrorLayout,
    TheHeader,
    TheFooter,
  },
  mixins: [AuthMixin],
};
</script>
